import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * ValuationResultsHardcoreTopSlice Widget
 */
@Component({
  selector: 'valuation-results-hardcore-topslice-widget',
  templateUrl: './valuation-results-hardcore-topslice-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './valuation-results-hardcore-topslice-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValuationResultsHardcoreTopSliceWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'valuationResultsHardcoreTopSlice', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('valuationResultsHardcoreTopSlice').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('valuationResultsHardcoreTopSlice', this.getReport()).pipe();

  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    return data;
  }
}
